import React, { useState, useEffect } from "react";
import { Card, Form, Button, Row, Col, ListGroup } from "react-bootstrap";
import axiosClient from "../../config/axiosClient";
import API_ENDPOINTS from "../../config/api";

const PermissionManager = () => {
  const [targetType, setTargetType] = useState("department");
  const [targetList, setTargetList] = useState([]);
  const [selectedTargets, setSelectedTargets] = useState([]);
  const [menus, setMenus] = useState([]);
  const [checkedMenus, setCheckedMenus] = useState([]);

  // Hàm xây dựng cây menu
  const buildMenuTree = (flatMenus) => {
    const map = {};
    const roots = [];
    flatMenus.forEach(m => { map[m.id] = { ...m, children: [] }; });
    flatMenus.forEach(m => {
      if (m.parentId && map[m.parentId]) {
        map[m.parentId].children.push(map[m.id]);
      } else {
        roots.push(map[m.id]);
      }
    });
    return roots;
  };

  // Load danh sách menu
  useEffect(() => {
    axiosClient.get(API_ENDPOINTS.menus).then(res => setMenus(res.data || []));
  }, []);

  // Load danh sách target (Dept/User) khi đổi loại
  useEffect(() => {
    const endpoint = targetType === "department" ? API_ENDPOINTS.departments : API_ENDPOINTS.users;
    axiosClient.get(endpoint).then(res => setTargetList(res.data || [])).catch(() => setTargetList([]));
    setSelectedTargets([]);
    setCheckedMenus([]);
  }, [targetType]);

  // Load quyền cũ khi chọn ĐÚNG 1 target
  useEffect(() => {
    if (selectedTargets.length === 1) {
      const targetId = selectedTargets[0];
      axiosClient.get(API_ENDPOINTS.getPermissions(targetType, targetId))
        .then(res => setCheckedMenus(res.data || []))
        .catch(err => {
          console.error("Error loading permissions:", err);
          setCheckedMenus([]); // Reset nếu lỗi
        });
    } else {
      setCheckedMenus([]);
    }
  }, [selectedTargets, targetType]);

  const handleSave = async () => {
    if (selectedTargets.length === 0) return alert("Please select at least one target!");
    try {
      await axiosClient.post(API_ENDPOINTS.savePermissions, {
        targetIds: selectedTargets,
        menuIds: checkedMenus,
        type: targetType
      });
      alert("Permissions updated successfully!");
    } catch (err) { alert("Error saving permissions!"); }
  };

  const getAllChildIds = (item) => {
    let ids = [item.id];
    if (item.children) {
      item.children.forEach(child => { ids = [...ids, ...getAllChildIds(child)]; });
    }
    return ids;
  };

  const toggleMenu = (node) => {
    const idsToToggle = getAllChildIds(node);
    const isAlreadyChecked = checkedMenus.includes(node.id);
    
    if (isAlreadyChecked) {
      setCheckedMenus(prev => prev.filter(id => !idsToToggle.includes(id)));
    } else {
      setCheckedMenus(prev => [...new Set([...prev, ...idsToToggle])]);
    }
  };

  const toggleAll = () => {
    setCheckedMenus(checkedMenus.length === menus.length ? [] : menus.map(m => m.id));
  };

  const renderMenuNode = (node) => (
    <React.Fragment key={node.id}>
      <ListGroup.Item className={node.parentId ? "ms-4" : "fw-bold bg-light"}>
        <Form.Check 
          type="checkbox" 
          label={node.title}
          checked={checkedMenus.includes(node.id)}
          onChange={() => toggleMenu(node)}
        />
      </ListGroup.Item>
      {node.children && node.children.map(child => renderMenuNode(child))}
    </React.Fragment>
  );

  return (
    <div className="container-fluid p-4">
      <Card className="shadow-sm border-0">
        <Card.Header className="bg-primary text-white fw-bold">PERMISSION MANAGEMENT</Card.Header>
        <Card.Body>
          <Row>
            <Col md={4} className="border-end">
              <Form.Group className="mb-3">
                <Form.Label className="small fw-bold">Target Type</Form.Label>
                <Form.Select value={targetType} onChange={(e) => setTargetType(e.target.value)}>
                  <option value="department">Department</option>
                  <option value="user">User</option>
                </Form.Select>
              </Form.Group>

              <Form.Group>
                <Form.Label className="small fw-bold">Select {targetType === 'department' ? 'Departments' : 'Users'}</Form.Label>
                <div className="border p-2" style={{ height: '300px', overflowY: 'auto' }}>
                  {targetList.map(item => (
                    <Form.Check 
                      key={item.id} type="checkbox" 
                      label={item.title || item.employeeName || item.name || "Unnamed"} 
                      checked={selectedTargets.includes(item.id)}
                      onChange={() => setSelectedTargets(prev => 
                        prev.includes(item.id) ? prev.filter(i => i !== item.id) : [...prev, item.id]
                      )}
                    />
                  ))}
                </div>
              </Form.Group>
            </Col>

            <Col md={8}>
              <div className="d-flex justify-content-between align-items-center mb-2">
                <h6 className="fw-bold">Menu Structure</h6>
                <Button variant="outline-primary" size="sm" onClick={toggleAll}>Check All</Button>
              </div>
              <ListGroup className="mb-3" style={{ height: '350px', overflowY: 'auto' }}>
                {buildMenuTree(menus).map(m => renderMenuNode(m))}
              </ListGroup>
              <Button variant="success" className="w-100 fw-bold" onClick={handleSave}>SAVE PERMISSIONS</Button>
            </Col>
          </Row>
        </Card.Body>
      </Card>
    </div>
  );
};

export default PermissionManager;